import { PageHeaderStaticProps } from '@procureai/ui-mui';

import { ModulePageTabs, ModulePageTabsProps } from '~/components/ModulePageTabs/ModulePageTabs';

import { PageHeaderStaticStyled } from './ModulePageHeader.styled';

export interface ModulePageHeaderProps extends PageHeaderStaticProps {
  tabs?: ModulePageTabsProps['items'];
}

export const ModulePageHeader = ({ tabs, ...props }: ModulePageHeaderProps) => {
  return (
    <PageHeaderStaticStyled divider hasTabs={!!tabs} {...props}>
      {tabs && <ModulePageTabs items={tabs} />}
    </PageHeaderStaticStyled>
  );
};
